import { fetcher } from "utils";
import { IPage, IJSendSuccessResponse, IWithMeta, UsersStoreSerialized, IPageMeta } from "typings";

export function get__api__v1__userables__stores(params: {
  page: IPage;
}): Promise<IJSendSuccessResponse<IWithMeta<UsersStoreSerialized[], IPageMeta>>> {
  return fetcher.get("/api/v1/userables/stores", params);
}
